/* @flow */
import * as React from 'react';

import DatePicker from 'react-datepicker';
import styles from './styles.module.scss';

import 'moment/locale/it';

type Props = {
  title?: string,
  label?: string,
  children?: any,
};

const InputDatePicker = (props: Props): React$Element<any> => {
  const { label, ...rest } = props;
  return (
    <label className={styles.container}>
      <div className={styles.label}>{label}</div>
      <DatePicker {...rest} locale="it-IT" className={styles.input} todayButton={'Oggi'} />
    </label>
  );
};

export default InputDatePicker;
